module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Frying-pan-7607ffb08b424d73cf3b6240bed9a346.svg";